import { CrudStoreItemCore } from 'src/core/classes/services/InitializationServiceCore'
import VersionStoreService from 'src/core/classes/services/VersionStoreService'
import { CORE_FORM } from 'src/core/constants'
import { GROUP_NAME_LOV_KEY } from 'src/core/sitebuilder/widgets/sitePagesDetails/constants'
import { CrudStore } from 'src/core/types/crudStore'

const getGroupSource = (key: string) => {
  const source = CrudStore.get(CrudStoreItemCore.Dropdowns, key)
  source.setRoot(GROUP_NAME_LOV_KEY)
  source.setPaging({ page: 0, pageSize: 10000 })

  return source
}

export const createGroup = async (key: string, newValue: string, description: string) => {
  const LOVSource = getGroupSource(key)

  await LOVSource.create(`${CORE_FORM.dropdowns.id}`, [
    {
      DropdownKey: LOVSource.getRoot(),
      Description: description,
      Name: newValue,
      en: newValue,
      value: newValue,
    },
  ])
  await VersionStoreService.updateApiVersion('LOV_DD_table')
}
